import AppraisalMonthlyTracker from '../../../components/dashboard-comp/AppraisalMonthlyTracker';
import React from 'react';
import Halfarc from '../../../components/dashboard-comp/Halfarc';
import Calaneder from '../../../components/dashboard-comp/Calaneder';
import Dashboardnavbarcopy from '../../../layout/Dashboardnavbarcopy';
import Radicalchart from '../../../components/dashboard-comp/Radicalchart';
import NewEmployee from '../../../components/dashboard-comp/NewEmployee';
import JobInformation from '../../../components/dashboard-comp/JobInformation';
import TaskInformation from '../../../components/dashboard-comp/TaskInformation';
import Informationcomponent from '../../../components/dashboard-comp/Informationcomponent';
import BalanceAndRequestsBoard from '../../../components/dashboard-comp/BalanceAndRequests';


const Dashboard = () => {
  // Live time

  const [today, setDate] = React.useState(new Date());
  React.useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date());
    }, 60 * 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);


  const hour = today.getHours();
  const wish = `Good ${(hour < 12 && "Morning") || (hour < 17 && "Afternoon") || "Evening"
    } `;



  return (
    <div className='dashboard-designs'>
      <Dashboardnavbarcopy url="Dashboard" name={wish} />
      <div className='dashboard-designs-flex'>
        <div className='dashboard-designs-calendar' style={{ display: "flex", flexDirection: "column" }}>
          <Calaneder />
        </div>
        <div className='dashboard-designs-column' style={{ gap: '14px' }}>
          {/* <Halfarc /> */}
          <AppraisalMonthlyTracker customWidth='36vw' customHeight='72vh' />
          {/* <Radicalchart /> */}
          <div>
            <BalanceAndRequestsBoard viewType="requests" customHeight={'10vh'} />
          </div>
          {/* <TeamAttendanceBars /> */}

        </div>
      </div>
      <div className='dashboard-designs-flex' style={{ gap: '0px', marginTop: '16px' }}>
        <BalanceAndRequestsBoard viewType="leaves" />
      </div>

      <div className="db2-secondary-grid" style={{ marginTop: '-1px' }}>

        {/* Announcements */}
        <div className="db2-card">
          <div className="db2-card-header">
            <div className="db2-card-title">
              <div className="db2-card-icon db2-icon-blue">

                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="rgb(37, 118, 188)" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-speakerphone"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M18 8a3 3 0 0 1 0 6" /><path d="M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5" /><path d="M12 8l4.524 -3.77a.9 .9 0 0 1 1.476 .692v12.156a.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8" /></svg>
              </div>
              Employee Highlights
            </div>

          </div>
          <div className="db2-divider" />
          <Informationcomponent />
        </div>

        {/* Your Tasks */}
        <div className="db2-card">
          <div className="db2-card-header">
            <div className="db2-card-title">
              <div className="db2-card-icon db2-icon-blue">

                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="rgb(37, 118, 188)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-clipboard-list"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" /><path d="M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2" /><path d="M9 12l.01 0" /><path d="M13 12l2 0" /><path d="M9 16l.01 0" /><path d="M13 16l2 0" /></svg>
              </div>
              Your Tasks
            </div>

          </div>
          <div className="db2-divider" />
          <TaskInformation />
        </div>

        {/* New Joining */}
        <div className="db2-card">
          <div className="db2-card-header">
            <div className="db2-card-title">
              <div className="db2-card-icon db2-icon-blue">

                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(37, 118, 188)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-users"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" /><path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /><path d="M21 21v-2a4 4 0 0 0 -3 -3.85" /></svg>
              </div>
              New Joining Employees
            </div>

          </div>
          <div className="db2-divider" />
          <NewEmployee />
        </div>

        {/* Job Openings */}
        <div className="db2-card">
          <div className="db2-card-header">
            <div className="db2-card-title">
              <div className="db2-card-icon db2-icon-blue">

                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="rgb(37, 118, 188)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-briefcase"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 9a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -9" /><path d="M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2" /><path d="M12 12l0 .01" /><path d="M3 13a20 20 0 0 0 18 0" /></svg>
              </div>
              Job Openings
            </div>
          </div>
          <div className="db2-divider" />
          <JobInformation />
        </div>

      </div>

    </div>
  )
}

export default Dashboard

